<template>
  <div class="ask-show-answer">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="q-show" v-if="info">
        <h1 class="conpdd" v-if="info.question">
          <img class="questag" v-lazy="img.questionicon">
          <span class="titleqa">{{ info.question }}</span>
        </h1>
        <p class="conpdd">{{ info.content }}</p>
        <img class="img" v-for="(img, index) in info.image" :key="'img_' + index" v-lazy="img"  @click="showImg(index)" />
        <div class="tag conpdd">
          <van-row type="flex" justify="space-between">
            <van-col span="18">
              <span class="f-12 c-gray mr-10" v-for="t in info.labels" :key="'label_' + t.id + '_id_' + info.id">{{ t.name }}</span>
            </van-col>
            <van-col span="6" class="tip" @click="goPost(5)">
              <span class="c-blue f-14">我要回答</span>
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="a-show" v-if="info && info.answers.length > 0">
        <div class="list-box" v-for="item in info.answers" :key="'list_' + item.id">
          <van-row class="conpdd" type="flex" justify="space-between" v-if="item.user">
           <!-- @click="goMy(item.user.id)" -->
           <van-col span="4">
            <img class="listhand" :src="item.user.headimg_url&&item.user.headimg_url.substring(0,5)=='https' ? item.user.headimg_url : img.avatar">
          </van-col>
          <!-- @click="goMy(item.user.id)" -->
          <van-col span="15">
            <div class="membername">
              {{item.user.user_name}}
            </div>
            <div class="sourtime">
              {{item.answer_time}}
            </div>
          </van-col>
          <van-col class="bintright" span="5">
            <!-- <van-button class="follow" :data-code="info.user.id" @click="follow()" icon="plus" color="#5F5B6B" size="small">关 注</van-button> -->
          </van-col>
        </van-row>
        <router-link :to="{name: 'LexusAskShowAnswer', params: {id: item.id}}" class="c-black">
          <div class="f-15 ellipsis-4 conpdd" v-if="item.content">
            <img class="answtag" v-if="item.content.text" :src="img.answericon">
            {{ item.content.text }}
          </div>
        </router-link>
        <img class="picone" v-if="item.content&&item.content.img" v-lazy="item.content.img" @click="showImgd(item.content.img)">
        <van-row class="sourtime conpdd f-12 mt-50" type="flex" justify="space-between">
          <van-col span="16">
            <!-- <span v-if="item.reply_num>0"></span> -->
            阅读量 {{item.reply_num}}
          </van-col>
          <van-col class="bintright" span="8" @click="toTip">
            举报
          </van-col>
        </van-row>
      </div>
    </div>
  </van-pull-refresh>
  <van-image-preview
  v-model="showState"
  :images="images"
  :startPosition="imgIndex"
  lazyLoad
  >
</van-image-preview>
<van-image-preview
v-model="showStated"
:images="imagesd"
lazyLoad
>
</van-image-preview>
</div>
</template>
<script>
  import ask from '../../../api/ask';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import {Row, Col, Tag, Button,PullRefresh} from "vant";

  export default {
    data () {
      return {
        params: {
          user_id: 0
        },
        question_id: 0,
        info: null,
        images:[],
        imgIndex:0,
        showState:false,
        imagesd:[],
        showStated:false,
        isLoading:false,
        img: {
          avatar: require('../../../assets/img/lexus/default.png'),
          parise: require('../../../assets/img/parise.png'),
          parise_have: require('../../../assets/img/parise_have.png'),
          comment: require('../../../assets/img/comment.png'),
          question: require('../../../assets/img/question.png'),
          answer: require('../../../assets/img/answers.png'),
          answericon: require('../../../assets/img/lexus/answericon.png'),
          questionicon: require('../../../assets/img/lexus/questionicon.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.weburl=process.env.VUE_APP_URL
      let id = this.$route.params.id
      if(this.$util.isEmpty(id)) {
        this.$toast('问题不存在')
        return false
      }
      this.question_id = id
      this.getInfo()

    },
    activated () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      console.log('show-activated--')
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        }
      })
      this.getInfo()
    },
    watch: {
      '$route'() {
        if(this.$route.params.id != this.question_id) {
          this.question_id = this.$route.params.id
          this.getInfo()
        }
      }
    },
    methods: {
      setPraise (index) {
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        if(this.user) {
          let type = this.info.answers[index].is_praise ? 2 : 1;
          ask.setPraise({id: this.info.answers[index].id, type: type}).then(res => {
            if(res.data.state == 1) {
              if(type == 1) {
                this.info.answers[index].is_praise = 1
                this.info.answers[index].praise_num += 1
              } else {
                this.info.answers[index].is_praise = 0
                this.info.answers[index].praise_num -= 1
              }
            }
          })
        } else {
          this.$toast('请先登录')
          return false
        }

      },
      toTip() {
        this.$toast.success('举报成功')
      },
      getInfo () {
        this.params.user_id = this.user ? this.user.id : 0
        ask.getShow(this.question_id, this.params).then(res => {
          if(res.data.state == 1) {
            this.info = res.data.data
            this.images = []
            if(res.data.data.image){
             for(let i of res.data.data.image) {
              this.images.push(i)
            }
          }
          if(res.data.data.question){
            document.title = res.data.data.question;
            document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.data.question)
            document.querySelector('meta[name="description"]').setAttribute('content', res.data.data.question)
          }
          var params={
            event_code: '凌志范儿问答',
            event_id: this.info.id,
            title: this.info.question,
            value: '',
            path: '/Lexus/Ask/Show.vue',
            user_id: this.user.id,
            source: this.source
          }
          common.BurialPoint(params).then(res => {
            if(res.data.state==1){

            }
          })
        }
      })
      },
      showImg(key){
        this.imgIndex = key
        this.showState = true
      },
      showImgd(image){
       var images=[]
       images.push(image)
       this.imagesd=images
       this.showStated=true
     },
     onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.getInfo()
      }, 500);
    },
    goPost(type){
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
          var params={
            qid:this.info.id,
            type:type,
            title:this.info.question
          }
          this.$appService.goPost(params)
        } else {
          var params={
            pagetype:1,
            qid:this.info.id,
            type:type,
            title:this.info.question
          }
          this.$appService.needLogin(params)
        }
      })
    },
    goMy(id){
     var params={
      url:this.weburl+'/lexus/my/other/'+id+'?source='+this.source ,
      isReturn: true 
    }
    this.$appService.openWebView(params)
  },
},
components: {
  [Row.name]: Row,
  [Col.name]: Col,
  [Tag.name]: Tag,
  [Button.name]: Button,
  [PullRefresh.name]:PullRefresh
}
};
</script>

<style lang="scss">
.ask-show-answer {
  background-color: #F0F0F0;
  .conpdd{
    padding: 0 15px;
  }
  .mt-50{
    margin-top: 50px !important;
  }
  .img {
    width: 100%;
    height: 230px;
    margin-top: 39px;
    display: block;
    object-fit: cover;
  }
  .q-show {
    padding: 20px 0;
    overflow: hidden;
    background-color: #FFF;
    border-bottom: 1px solid #EAEAEA;
    h1 {
      font-size: 15px;
    }
    p {
      margin: 0;
      font-size: 15px;
      line-height: 22px;
      color: #3A3A3A;
    }
    .van-tag {
      color: #fff;

    }
    .tip {
      text-align: right;

      .c-blue {
       font-size: 12px;
       color: #728FC4;
       background: #F2F6FA url(../../../assets/img/lexus/listask.png) no-repeat 8px center;
       background-size: 13px auto;
       width: 80px;
       height: 25px;
       line-height: 25px;
       display: inline-block;
       text-align: left;
       padding-left: 25px;
       border-radius: 1px;
       box-sizing: border-box;
     }
   }
   .titleqa{
    font-size: 15px;
    vertical-align: middle;
  }
}
.a-show {
 margin-top: 10px;
 background-color: #FFF;
 .f-15{
  line-height: 22px;
  margin-top: 21px;
}
.list-box {
  border-bottom: 1px solid #EAEAEA;
  padding-bottom: 20px;
  padding-top: 20px;
  .picone{
    width:100%;
    height:230px;
    margin-top: 15px;
    object-fit: cover;
  }
  .listitle{
    font-size: 16px;
    font-weight:bold;
    line-height: 32px;
    letter-spacing: 1.4px;
    margin: 10px 0;

    &.listitle2 {
      margin-top: 0;
    }
  }
  .sourtime{
    font-size: 12px;
    color: #9A9A9A;
    margin-top: 5px;
    .c-blue {
      font-size: 12px;
      color: #FFF;
      background: #33A1FF url(../../../assets/img/answer-button.png) no-repeat 8px center;
      background-size: 13px auto;
      width: 80px;
      height: 25px;
      line-height: 25px;
      display: inline-block;
      text-align: left;
      padding-left: 25px;
      border-radius: 12px;
      box-sizing: border-box;
    }
  }
  .bintright{
    text-align:right;
    .binbox{
      margin-left:20px;
    }

    .binpic{
      width:15px;
      height:14px;
      margin-right:8px;
      vertical-align: middle;
    }
  }
  .pic-box {

    .pic_thumb {
      border-radius: 5px;
      width: 100%;
      height: 225px;
      object-fit: cover;
      display: block;
    }
  }
  .listhand{
    width:40px;
    height:40px;
    border-radius:1.5px;
  }
  .membername{
    font-size: 13px;
    font-weight: bold;
    color: #605C6B;
  }
}
}
.mr-10{
  margin-right: 10px;
}
a{
  color: #3A3A3A;
}
.answtag{
  width: 15px;
  height: 15px;
  margin-right: 10px;
}
.questag{
  width: 15px;
  height: 15px;
  margin-right: 10px;
  vertical-align: middle;
}
.follow{
  vertical-align: super;
}
}
</style>
